var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person",
    transform: "translate(66.7 -14.994)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "base",
    width: 40,
    height: 40,
    transform: "translate(-66.7 14.994)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-73 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M15.248,79.481H36.78a5.03,5.03,0,0,0,4.948-5.1,5.246,5.246,0,0,0-2.217-4.288A53.783,53.783,0,0,0,33.969,66.7h0a11.329,11.329,0,0,1-4.829,3.553,9.034,9.034,0,0,1-3.127.572,8.779,8.779,0,0,1-3.087-.531,10.825,10.825,0,0,1-4.868-3.553c-1.306.694-3.285,1.878-5.541,3.389A5.191,5.191,0,0,0,10.3,74.418h0A5.02,5.02,0,0,0,15.248,79.481Z",
    transform: "translate(0 -39.487)",
    fill: "#1b00ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M23.926,19.76a7.374,7.374,0,0,0,1.559,3.267,10.364,10.364,0,0,0,6,7.064,6.825,6.825,0,0,0,4.87,0,10.282,10.282,0,0,0,6-7.064,7.374,7.374,0,0,0,1.559-3.267c.351-1.307.7-3.144-.234-4.451a.562.562,0,0,1-.117-.163c.078-.449.117-.9.156-1.307,1.091-7.677-2.961-8.167-3.429-8.167-.039,0-.039-.041-.078-.041a5.293,5.293,0,0,0-5.767-3.553C31.914,2.65,26.615,2,26.615,2a2.648,2.648,0,0,0,.9,2c-4.481,2.858-3.663,8.983-3.234,11.148a.562.562,0,0,0-.117.163C23.225,16.615,23.576,18.453,23.926,19.76Zm2.338-3.593h.117v-.041A3.827,3.827,0,0,1,27.628,12a10.855,10.855,0,0,0,7.091-.98c6.156-2.777,6.7,5.145,6.7,5.145h.117c.623,0,1.286.531.584,3.063-.545,2-1.052,2.573-1.4,2.573a8.418,8.418,0,0,1-4.987,6.452,5.3,5.3,0,0,1-3.663,0A8.5,8.5,0,0,1,27.082,21.8c-.39-.041-.9-.613-1.4-2.573C24.978,16.656,25.641,16.166,26.264,16.166Z",
    transform: "translate(-7.845 0)",
    fill: "#1b00ff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.4ddbfb1c25eeda5f20f23674707ebafd.svg";
export { ForwardRef as ReactComponent };